import { render } from "./Reports.vue?vue&type=template&id=04c5e352&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=04c5e352&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04c5e352"

export default script